module.exports = __webpack_public_path__ + "static/assets/76602ba3bf56e6ba492223964ae32e5a.png";